import { resize } from './components/header/resize.js';
import { scrollAnimation } from './components/header/scrollAnimation.js';

resize();
scrollAnimation();